
import { createWidgetMixin } from 'vue-instantsearch/vue2/es';
import { connectSearchBox } from 'instantsearch.js/es/connectors/index.js';

/**
 * VirtualSearchBox
 * Used to allow query state to apply on an index without rendering a visible search box.
 */
export default {
  name: 'VirtualSearchBox',
  mixins: [createWidgetMixin({ connector: connectSearchBox })],
  render() {
    return null;
  },
};
